export enum TranslationKey {

    AlwaysShowChart = "AlwaysShowChart",
    BigMovement = "BigMovement",
    ConsecutiveCandles = "ConsecutiveCandles",
    Daily = "Daily",
    FromNow = "FromNow",
    Hourly = "Hourly",
    Lessons = "Lessons",
    NewTrading = "NewTrading",
    NextLesson = "NextLesson",
    NotifyBy = "NotifyBy",
    PriceDirection = "PriceDirection",
    PriceType = "PriceType",
    Recurring = "Recurring",
    SetAlert = "SetAlert",
    accept = "accept",
    accountDemo = "account.demo",
    accountReadyToUse = "accountReadyToUse",
    accountReal = "account.real",
    accountRegistrationData = "accountRegistrationData",
    accountStatements = "accountStatements",
    actions = "actions",
    active = "active",
    add = "add",
    addASymbol = "addASymbol",
    addLossCoverage = "addLossCoverage",
    addSpreadCashback = "addSpreadCashback",
    addSymbol = "addSymbol",
    addSymbols = "addSymbols",
    addToWatchlist = "addToWatchlist",
    added = "added",
    addedToWatchlist = "addedToWatchlist",
    addedToYourWatchlist = "addedToYourWatchlist",
    ago = "ago",
    agree = "agree",
    alert = "alert",
    alertPriceTypeDescription = "alertPriceTypeDescription",
    alertSuccessfullyCreated = "alertSuccessfullyCreated",
    alertSuccessfullyModified = "alertSuccessfullyModified",
    alertType = "alertType",
    all = "all",
    allowNotificationsWarning = "allowNotificationsWarning",
    alreadyHaveAccount = "alreadyHaveAccount",
    amount = "amount",
    annualReportPending = "annualReportPending",
    annualReportSuccess = "annualReportSuccess",
    apply = "apply",
    areYouSureYouWantDelete = "areYouSureYouWantDelete",
    at = "at",
    atRate = "atRate",
    attention = "attention",
    availablePromotions = "availablePromotions",
    back = "back",
    backTo = "backTo",
    bannerBoChatReopenBtn = "banner.boChatReopen.btn",
    bannerBoChatReopenNewMessages = "banner.boChatReopen.newMessages",
    bannersAccountAccountPendingApproval = "banners.account.accountPendingApproval",
    bannersAccountCompleteYourAccount = "banners.account.completeYourAccount",
    bannersAccountLastStep = "banners.account.lastStep",
    bannersAccountProblemWithVerificationDocument = "banners.account.problemWithVerificationDocument",
    bannersAccountReadyToStart = "banners.account.readyToStart",
    bannersAccountTopUpAccount = "banners.account.topUpAccount",
    bannersAccountUpdateDocuments = "banners.account.updateDocuments",
    bannersAccountVerifyYourIdentity = "banners.account.verifyYourIdentity",
    bannersBecomeAProfessionalBecomeAProfessional = "banners.becomeAProfessional.becomeAProfessional",
    bannersBecomeAProfessionalDidNotMeetCriteria = "banners.becomeAProfessional.didNotMeetCriteria",
    bannersBecomeAProfessionalInfo = "banners.becomeAProfessional.info",
    bannersBecomeAProfessionalLearnMore = "banners.becomeAProfessional.learnMore",
    bannersBecomeAProfessionalTitle = "banners.becomeAProfessional.title",
    bannersLiquidationInfo = "banners.liquidation.info",
    bannersLiquidityTitle = "banners.liquidity.title",
    bannersMarginCallInfo = "banners.marginCall.info",
    bannersWithdrawalCancelRequest = "banners.withdrawal.cancelRequest",
    bannersWithdrawalDocumentsAreRequired = "banners.withdrawal.documentsAreRequired",
    bannersWithdrawalProcessingWithdrawal = "banners.withdrawal.processingWithdrawal",
    bannersWithdrawalSuccessInfo = "banners.withdrawal.successInfo",
    bannersWithdrawalSuccessfullyProcessed = "banners.withdrawal.successfullyProcessed",
    bannersWithdrawalUploadDocuments = "banners.withdrawal.uploadDocuments",
    bannersWithdrawalViewDetails = "banners.withdrawal.viewDetails",
    breakout = "breakout",
    brokerNotFound = "brokerNotFound",
    buy = "buy",
    buyEntryLimit = "buyEntryLimit",
    buyOrSell = "buyOrSell",
    callMe = "callMe",
    callMeRequested = "callMeRequested",
    cancel = "cancel",
    change = "change",
    changePassword = "changePassword",
    changePasswordNewPassword = "changePassword.newPassword",
    changePasswordSubTitle = "changePassword.subTitle",
    changeTitleAlert = "changeTitleAlert",
    chart = "chart",
    chartPattern = "chartPattern",
    chartPatterns = "chartPatterns",
    chatCollapse = "chat.collapse",
    chatDisconnected = "chat.disconnected",
    chatGreeting = "chat.greeting",
    chatInfo = "chat.info",
    chatInit = "chat.init",
    chatInitManager = "chat.init.manager",
    chatStart = "chat.start",
    chatTitle = "chat.title",
    chatTypeMessage = "chat.typeMessage",
    checkYourInbox = "checkYourInbox",
    checkYourInboxConfirmAccount = "checkYourInbox.confirmAccount",
    checkYourInboxEmailSentFeedback = "checkYourInbox.emailSentFeedback",
    chooseLanguage = "chooseLanguage",
    clear = "clear",
    clearAll = "clearAll",
    close = "close",
    closeAt = "closeAt",
    closeOnlyDate = "closeOnlyDate",
    closeOrderAt = "closeOrderAt",
    closeOutMethodChanged = "closeOutMethodChanged",
    closeRate = "closeRate",
    closeTrade = "closeTrade",
    closeTradeUpper = "closeTradeUpper",
    closeTrades = "closeTrades",
    closeTradesUpper = "closeTradesUpper",
    closed = "closed",
    closedDeal = "closedDeal",
    closedTradesNoTrades = "closedTrades.noTrades",
    commonPractice = "commonPractice",
    compactListView = "compactListView",
    confirm = "confirm",
    congratulations = "congratulations",
    continentAf = "continent.af",
    continentAs = "continent.as",
    continentEu = "continent.eu",
    continentNa = "continent.na",
    continentOc = "continent.oc",
    continentSa = "continent.sa",
    continueWith = "continueWith",
    copyToTrade = "copyToTrade",
    createAccount = "createAccount",
    createTrade = "createTrade",
    created = "created",
    currentRates = "currentRates",
    date = "date",
    dateRange = "dateRange",
    day = "day",
    days = "days",
    deal = "deal",
    dealingApprovingActions = "dealing.approving.actions",
    dealingApprovingAgreement = "dealing.approving.agreement",
    dealingDealsWereCreated = "dealing.deals.were.created",
    dealingDealsWereUpdated = "dealing.deals.were.updated",
    deleteAlert = "deleteAlert",
    deleteOrder = "deleteOrder",
    deleteOrderUpper = "deleteOrderUpper",
    deleteOrders = "deleteOrders",
    deleteOrdersUpper = "deleteOrdersUpper",
    deposit = "deposit",
    disclaimer = "disclaimer",
    disclaimerSignup = "disclaimer.signup",
    documentTitleAccountOverview = "document.title.accountOverview",
    documentTitleAccountSettings = "document.title.accountSettings",
    documentTitleAlerts = "document.title.alerts",
    documentTitleBuyOrSell = "document.title.buyOrSell",
    documentTitleChart = "document.title.chart",
    documentTitleEconomicCalendar = "document.title.economicCalendar",
    documentTitleLessons = "document.title.lessons",
    documentTitleMyTrades = "document.title.myTrades",
    documentTitleNews = "document.title.news",
    documentTitlePromotions = "document.title.promotions",
    documentTitleSignals = "document.title.signals",
    documentTitleSymbolSearch = "document.title.symbolSearch",
    documentTitleSymbols = "document.title.symbols",
    documentTitleTechnicalAnalysis = "document.title.technicalAnalysis",
    documentTitleTools = "document.title.tools",
    documentTitleTradingOpportunities = "document.title.tradingOpportunities",
    done = "done",
    dontHaveAccount = "dontHaveAccount",
    dontKnowBroker = "dontKnowBroker",
    editAlert = "editAlert",
    editOrder = "editOrder",
    editTrade = "editTrade",
    educationalTrade = "educationalTrade",
    email = "email",
    emerging = "emerging",
    enterYourEmail = "enterYourEmail",
    entry = "entry",
    entryOrder = "entryOrder",
    entryOrderDescription = "entryOrderDescription",
    errorFieldsMandatory = "error.fields.mandatory",
    errorGeneral = "error.general",
    errorHandlerPageMessage = "error.handlerPageMessage",
    errorHandlerPageReloadButtonText = "error.handlerPageReloadButtonText",
    errorModalRequired = "error.modal.required",
    errorPasswordsNotMatch = "error.passwords.not.match",
    estimatedAmount = "estimatedAmount",
    estimatedLoss = "estimatedLoss",
    estimatedProfit = "estimatedProfit",
    estimatedRate = "estimatedRate",
    expirationDate = "expirationDate",
    expirationDay = "expiration.day",
    expirationMonth = "expiration.month",
    expirationYear = "expiration.year",
    export = "export",
    failedClosePosition = "failedClosePosition",
    failedClosePositionDescription = "failedClosePositionDescription",
    features = "features",
    feddbackSuccessMessage = "feddback.successMessage",
    feedback = "feedback",
    feedbackFailedMessage = "feedback.failedMessage",
    feedbackHelpUs = "feedback.helpUs",
    feedbackQuestion = "feedback.question",
    feedbackSuccess = "feedback.success",
    feedbackTryAgain = "feedback.tryAgain",
    feedbackYourComment = "feedback.yourComment",
    fibonacci = "fibonacci",
    fibonacciPatterns = "fibonacciPatterns",
    filterAll = "filter.all",
    filterThisMonth = "filter.thisMonth",
    filterThisWeek = "filter.thisWeek",
    filterThisYear = "filter.thisYear",
    filterToday = "filter.today",
    filters = "filters",
    forceUpdateUp = "forceUpdateUp",
    forgotPassword = "forgotPassword",
    forgotPasswordVerificationSubtitle = "forgotPasswordVerificationSubtitle",
    forgotPasswordVerificationTitle = "forgotPasswordVerificationTitle",
    formFieldErrorEmail = "form.field.error.Email",
    formFieldErrorFullName = "form.field.error.FullName",
    formFieldErrorPassword = "form.field.error.Password",
    formFieldErrorPhoneNumber = "form.field.error.PhoneNumber",
    formFieldErrorReferralCode = "form.field.error.ReferralCode",
    funds = "funds",
    goToDemo = "goToDemo",
    goToReal = "goToReal",
    great = "great",
    headerAccountDetails = "header.account.details",
    headerAccountEquity = "header.accountEquity",
    headerAvailableLine = "header.availableLine",
    headerAvailableMargin = "header.availableMargin",
    headerBalance = "header.balance",
    headerDescriptionAccountEquity = "header.description.accountEquity",
    headerDescriptionAvailableLine = "header.description.availableLine",
    headerDescriptionAvailableMargin = "header.description.availableMargin",
    headerDescriptionBalance = "header.description.balance",
    headerDescriptionExposure = "header.description.exposure",
    headerDescriptionMarginLevel = "header.description.marginLevel",
    headerDescriptionUnrealizedProfit = "header.description.unrealizedProfit",
    headerDescriptionUsedMargin = "header.description.usedMargin",
    headerDescriptionWithdrawableEquity = "header.description.withdrawableEquity",
    headerExposure = "header.exposure",
    headerMarginLevel = "header.marginLevel",
    headerUnrealizedProfit = "header.unrealizedProfit",
    headerUsedMargin = "header.usedMargin",
    headerWithdrawableEquity = "header.withdrawableEquity",
    high = "high",
    highestRateToday = "highestRateToday",
    home = "home",
    hour = "hour",
    hours = "hours",
    info = "info",
    interval = "interval",
    keyLevel = "keyLevel",
    keyLevels = "keyLevels",
    latestNews = "latestNews",
    learnMoreAbout = "learnMoreAbout",
    legal = "legal",
    lessonsDownload = "lessons.download",
    lessonsEnableConfirmation = "lessons.enable.confirmation",
    lessonsFreeEbook = "lessons.freeEbook",
    lessonsFreeEbookDisabled = "lessons.freeEbook.disabled",
    lessonsFreeEbookManagerContact = "lessons.freeEbook.managerContact",
    lessonsInfoParagraph1 = "lessons.info.paragraph1",
    lessonsInfoParagraph2 = "lessons.info.paragraph2",
    lessonsPlatformTakeAWalk = "lessons.platform.takeAWalk",
    lessonsPlatformWalkthroughs = "lessons.platformWalkthroughs",
    lessonsRequestExtension = "lessons.request.extension",
    lessonsServiceExpiration = "lessons.service.expiration",
    lessonsVideos = "lessons.videos",
    lessonsVideosNotFound = "lessons.videosNotFound",
    lessonsViewed = "lessons.viewed",
    leverageChanged = "leverageChanged",
    leverageDisclaimerCheckbox = "leverage.disclaimer.checkbox",
    leverageDisclaimerMessage = "leverage.disclaimer.message",
    leverageDisclaimerTitle = "leverage.disclaimer.title",
    loading = "loading",
    loggedAs = "loggedAs",
    loginBtn = "loginBtn",
    loginTitle = "loginTitle",
    logout = "logout",
    logoutConfirmation = "logoutConfirmation",
    low = "low",
    lowestRateToday = "lowestRateToday",
    marketEntryOrdersDiff = "marketEntryOrdersDiff",
    marketOrder = "marketOrder",
    menuAccountOverview = "menu.accountOverview",
    menuAccountSettings = "menu.accountSettings",
    menuAlerts = "menu.alerts",
    menuEconomicCalendar = "menu.economicCalendar",
    menuLessons = "menu.lessons",
    menuLiveChat = "menu.liveChat",
    menuMyTrades = "menu.myTrades",
    menuNews = "menu.news",
    menuPromotions = "menu.promotions",
    menuSignals = "menu.signals",
    menuSupport = "menu.support",
    menuSymbols = "menu.symbols",
    menuTradingOpportunities = "menu.tradingOpportunities",
    minAmount = "minAmount",
    minimumUnits = "minimumUnits",
    minute = "minute",
    minutes = "minutes",
    minutesComplete = "minutesComplete",
    moreFilters = "moreFilters",
    myAccount = "myAccount",
    myTrades = "myTrades",
    myTradesActivityLog = "myTrades.activityLog",
    myTradesClosedTrade = "myTrades.closedTrade",
    myTradesClosedTrades = "myTrades.closedTrades",
    myTradesEntryOrders = "myTrades.entryOrders",
    myTradesNoActiveTrades = "myTrades.noActiveTrades",
    myTradesOpenTrades = "myTrades.openTrades",
    myWatchlist = "myWatchlist",
    newsNotFound = "news.notFound",
    newsNothingToShow = "news.nothingToShow",
    no = "no",
    noActiveAlerts = "noActiveAlerts",
    noActiveTrades = "noActiveTrades",
    noInternetConnection = "noInternetConnection",
    noResultsActivityLogs = "noResultsActivityLogs",
    noResultsClosedPositions = "noResultsClosedPositions",
    noResultsEntryOrders = "noResultsEntryOrders",
    noResultsOpenPositions = "noResultsOpenPositions",
    noResultsSignals = "noResultsSignals",
    noResultsSignalsWatchList = "noResultsSignalsWatchList",
    noWatchSymbols = "noWatchSymbols",
    notAllowedToTradeError = "notAllowedToTradeError",
    notEnoughMargin = "notEnoughMargin",
    nothingToShow = "nothingToShow",
    notificationTabAll = "notification.tab.all",
    notificationTabUnread = "notification.tab.unread",
    notifications = "notifications",
    oco = "oco",
    ocoSlTp = "ocoSlTp",
    ok = "ok",
    openRateToday = "openRateToday",
    opened = "opened",
    orderDeleted = "orderDeleted",
    orderExecuted = "orderExecuted",
    orderFailedToDelete = "orderFailedToDelete",
    orderPlaced = "orderPlaced",
    orderRate = "orderRate",
    orderRateRange = "orderRateRange",
    orderUnits = "orderUnits",
    orderUpdated = "orderUpdated",
    orders = "orders",
    password = "password",
    passwordChanged = "password.changed",
    passwordHasExpired = "passwordHasExpired",
    passwordNew = "password.new",
    passwordNewRetype = "password.new.retype",
    pattern = "pattern",
    patternTypes = "patternTypes",
    placeOrder = "placeOrder",
    pleaseSelectPatternType = "pleaseSelectPatternType",
    popupMessageSwitchToLive = "popup.message.switchToLive",
    positions = "positions",
    price = "price",
    priceTitleAlert = "priceTitleAlert",
    probability = "probability",
    profile = "profile",
    promosPromosForTheAccount = "promos.promosForTheAccount",
    promosPromosForThisPosition = "promos.promosForThisPosition",
    promotionBonus = "promotion.bonus",
    promotionChangedInbox = "promotionChangedInbox",
    promotionCreditConfirmReject = "promotion.credit.confirm.reject",
    promotionCreditDescription = "promotion.credit.description",
    promotionCreditReceived = "promotion.credit.received",
    promotionCreditRejected = "promotion.credit.rejected",
    promotionDescriptionEducational = "promotion.description.educational",
    promotionDescriptionPosition_insurance = "promotion.description.position_insurance",
    promotionDescriptionProtected = "promotion.description.protected",
    promotionDescriptionRebate_plan = "promotion.description.rebate_plan",
    promotionDescriptionRolling_contract = "promotion.description.rolling_contract",
    promotionDescriptionRollover_discount = "promotion.description.rollover_discount",
    promotionDescriptionSpread_cashback = "promotion.description.spread_cashback",
    promotionDescriptionVault = "promotion.description.vault",
    promotionEducationalLongDescription = "promotion.educational.longDescription",
    promotionEducationalPositionRemaining = "promotion.educational.positionRemaining",
    promotionExpirationDate = "promotion.expirationDate",
    promotionExpireOn = "promotion.expireOn",
    promotionInfoEducational = "promotion.info.educational",
    promotionInfoPosition_insurance = "promotion.info.position_insurance",
    promotionInfoProtected = "promotion.info.protected",
    promotionInfoRebate_plan = "promotion.info.rebate_plan",
    promotionInfoRolling_contract = "promotion.info.rolling_contract",
    promotionInfoRollover_discount = "promotion.info.rollover_discount",
    promotionInfoSpread_cashback = "promotion.info.spread_cashback",
    promotionInfoVault = "promotion.info.vault",
    promotionInsuranceLongDescription = "promotion.insurance.longDescription",
    promotionInsurancePositionRemaining = "promotion.insurance.positionRemaining",
    promotionModalNoPromotions = "promotion.modal.noPromotions",
    promotionModalRebatePlanInfo = "promotion.modal.rebatePlan.info",
    promotionModalRebatePlanInfoLastLevel = "promotion.modal.rebatePlan.info.last.level",
    promotionModalRebatePlanInfoReachedLastLevel = "promotion.modal.rebatePlan.info.reached.last.level",
    promotionModalRebatePlanInfoReachedNextLevel = "promotion.modal.rebatePlan.info.reached.next.level",
    promotionModalRebatePlanSubtitle = "promotion.modal.rebatePlan.subtitle",
    promotionModalVaultCashoutAmount = "promotion.modal.vault.cashoutAmount",
    promotionModalVaultCashoutVolumeL30d = "promotion.modal.vault.cashoutVolumeL30d",
    promotionModalVaultCurrentCashoutVolume = "promotion.modal.vault.currentCashoutVolume",
    promotionModalVaultEquity = "promotion.modal.vault.equity",
    promotionModalVaultExpires = "promotion.modal.vault.expires",
    promotionModalVaultExpiresInfo1 = "promotion.modal.vault.expires.info.1",
    promotionModalVaultExpiresInfo2 = "promotion.modal.vault.expires.info.2",
    promotionModalVaultTc = "promotion.modal.vault.tc",
    promotionOverviewPosition_insurance = "promotion.overview.position_insurance",
    promotionOverviewRebate_plan = "promotion.overview.rebate_plan",
    promotionOverviewRollover_discount = "promotion.overview.rollover_discount",
    promotionOverviewSpread_cashback = "promotion.overview.spread_cashback",
    promotionOverviewVault = "promotion.overview.vault",
    promotionProtectedLongDescription = "promotion.protected.longDescription",
    promotionProtectedPositionRemaining = "promotion.protected.positionRemaining",
    promotionRollOverLongDescription = "promotion.RollOver.longDescription",
    promotionRollingContractLongDescription = "promotion.rollingContract.longDescription",
    promotionSpreadCashbackLongDescription = "promotion.spreadCashback.longDescription",
    promotionSpreadCashbackPositionRemaining = "promotion.spreadCashback.positionRemaining",
    promotionSubtitleEducational = "promotion.subtitle.educational",
    promotionSubtitlePosition_insurance = "promotion.subtitle.position_insurance",
    promotionSubtitleProtected = "promotion.subtitle.protected",
    promotionSubtitleRebate_plan = "promotion.subtitle.rebate_plan",
    promotionSubtitleRolling_contract = "promotion.subtitle.rolling_contract",
    promotionSubtitleRollover_discount = "promotion.subtitle.rollover_discount",
    promotionSubtitleSpread_cashback = "promotion.subtitle.spread_cashback",
    promotionSubtitleVault = "promotion.subtitle.vault",
    promotionTitleEducational = "promotion.title.educational",
    promotionTitlePosition_insurance = "promotion.title.position_insurance",
    promotionTitleProtected = "promotion.title.protected",
    promotionTitleRebate_plan = "promotion.title.rebate_plan",
    promotionTitleRolling_contract = "promotion.title.rolling_contract",
    promotionTitleRollover_discount = "promotion.title.rollover_discount",
    promotionTitleSpread_cashback = "promotion.title.spread_cashback",
    promotionTitleVault = "promotion.title.vault",
    promotionVaultWarning = "promotion.vault.warning",
    protected = "protected",
    protectedTrade = "protectedTrade",
    protectedTradesLeft = "protectedTradesLeft",
    range = "range",
    reject = "reject",
    rememberMe = "rememberMe",
    removeFromWatchlist = "removeFromWatchlist",
    removedFromYourWatchlist = "removedFromYourWatchlist",
    required = "required",
    requiredMargin = "requiredMargin",
    resendEmail = "resendEmail",
    resetPassword = "resetPassword",
    resetYourPassword = "resetYourPassword",
    risingWedge = "risingWedge",
    risingWedgeEmerging = "risingWedgeEmerging",
    rolloverFees = "rolloverFees",
    rolloverFeesConversion = "rolloverFeesConversion",
    rolloverFeesRolloverConversion = "rolloverFeesRolloverConversion",
    save = "save",
    search = "search",
    searchSymbol = "searchSymbol",
    second = "second",
    seconds = "seconds",
    selectBroker = "selectBroker",
    selectCountryCode = "selectCountryCode",
    selectSymbol = "selectSymbol",
    selectSymbols = "selectSymbols",
    sell = "sell",
    sellEntryLimit = "sellEntryLimit",
    sendVerificationCode = "sendVerificationCode",
    setAnAlert = "setAnAlert",
    settings = "settings",
    settingsAnnualAnnualStatement = "settings.annual.annualStatement",
    settingsAnnualChooseYear = "settings.annual.chooseYear",
    settingsAnnualInfo = "settings.annual.info",
    settingsAnnualSendToEmail = "settings.annual.sendToEmail",
    settingsChangePswConfirmPsw = "settings.changePsw.ConfirmPsw",
    settingsChangePswCurrentPsw = "settings.changePsw.currentPsw",
    settingsChangePswNewPsw = "settings.changePsw.newPsw",
    settingsCloseOutChangeCloseOutMethod = "settings.closeOut.changeCloseOutMethod",
    settingsCloseOutChooseMethod = "settings.closeOut.chooseMethod",
    settingsCloseOutCurrentMethod = "settings.closeOut.currentMethod",
    settingsCloseOutInfo = "settings.closeOut.info",
    settingsCloseOutPolicyInfo = "settings.closeOut.policyInfo",
    settingsCloseOutTitle = "settings.closeOut.title",
    settingsCompleteRegistration = "settings.complete.registration",
    settingsCompleteRegistrationInfo = "settings.complete.registration.info",
    settingsFundsAvailableMargin = "settings.funds.availableMargin",
    settingsFundsBalance = "settings.funds.balance",
    settingsFundsCurrentMarginLevel = "settings.funds.currentMarginLevel",
    settingsFundsUsedMargin = "settings.funds.usedMargin",
    settingsMyLeverageChangeMyLeverage = "settings.myLeverage.changeMyLeverage",
    settingsMyLeverageConfirm = "settings.myLeverage.confirm",
    settingsMyLeverageCurrentRatio = "settings.myLeverage.currentRatio",
    settingsMyLeverageInfo = "settings.myLeverage.info",
    settingsMyLeverageMaxLeverage = "settings.myLeverage.maxLeverage",
    settingsMyLeverageReminder = "settings.myLeverage.reminder",
    settingsMyLeverageTitle = "settings.myLeverage.title",
    settingsProfessionalBecomePro = "settings.professional.becomePro",
    settingsProfessionalInfo = "settings.professional.info",
    settingsProfessionalTitle = "settings.professional.title",
    settingsProfileAccountNumber = "settings.profile.accountNumber",
    settingsProfileAddress = "settings.profile.address",
    settingsProfileBrandEmails = "settings.profile.brandEmails",
    settingsProfileCommunicationPreferences = "settings.profile.communicationPreferences",
    settingsProfileCountryCode = "settings.profile.countryCode",
    settingsProfileCountryOfBirth = "settings.profile.countryOfBirth",
    settingsProfileDarkTheme = "settings.profile.darkTheme",
    settingsProfileDateOfBirth = "settings.profile.dateOfBirth",
    settingsProfileDocuments = "settings.profile.documents",
    settingsProfileDocumentsContact = "settings.profile.documents.contact",
    settingsProfileDocumentsUpload = "settings.profile.documents.upload",
    settingsProfileDocumentsVerified = "settings.profile.documents.verified",
    settingsProfileEmail = "settings.profile.email",
    settingsProfileGetCode = "settings.profile.getCode",
    settingsProfileInvalidEmail = "settings.profile.invalidEmail",
    settingsProfileInvalidPhoneNumber = "settings.profile.invalidPhoneNumber",
    settingsProfileName = "settings.profile.name",
    settingsProfileNationality = "settings.profile.nationality",
    settingsProfileNewEmail = "settings.profile.newEmail",
    settingsProfilePhoneCalls = "settings.profile.phoneCalls",
    settingsProfilePhoneNumber = "settings.profile.phoneNumber",
    settingsProfilePopupSound = "settings.profile.popupSound",
    settingsProfilePushNotifications = "settings.profile.pushNotifications",
    settingsProfileShareInformation = "settings.profile.shareInformation",
    settingsProfileSms = "settings.profile.sms",
    settingsProfileVerified = "settings.profile.verified",
    settingsProfileVerifyEmail = "settings.profile.verifyEmail",
    settingsProfileVerifyNumber = "settings.profile.verifyNumber",
    settingsTopUpAccountLimit = "settings.topUp.accountLimit",
    settingsTopUpInfo = "settings.topUp.info",
    settingsTopUpLeftToTopUp = "settings.topUp.leftToTopUp",
    settingsTopUpManageLimits = "settings.topUp.manageLimits",
    settingsTopUpTitle = "settings.topUp.title",
    settingsTransactionsHistory = "settings.transactions.history",
    settingsWithdrawalsAvailableFunds = "settings.withdrawals.availableFunds",
    settingsWithdrawalsInfo = "settings.withdrawals.info",
    settingsWithdrawalsMakeWithdrawal = "settings.withdrawals.makeWithdrawal",
    settingsWithdrawalsPendingInfo = "settings.withdrawals.pendingInfo",
    settingsWithdrawalsTitle = "settings.withdrawals.title",
    showOnlyOnesWithProbability = "showOnlyOnesWithProbability",
    signUpBtn = "signUpBtn",
    signUpErrorCode1 = "signUp.error.code.1",
    signUpErrorCode10 = "signUp.error.code.10",
    signUpErrorCode11 = "signUp.error.code.11",
    signUpErrorCode12 = "signUp.error.code.12",
    signUpErrorCode13 = "signUp.error.code.13",
    signUpErrorCode14 = "signUp.error.code.14",
    signUpErrorCode15 = "signUp.error.code.15",
    signUpErrorCode16 = "signUp.error.code.16",
    signUpErrorCode17 = "signUp.error.code.17",
    signUpErrorCode2 = "signUp.error.code.2",
    signUpErrorCode3 = "signUp.error.code.3",
    signUpErrorCode4 = "signUp.error.code.4",
    signUpErrorCode5 = "signUp.error.code.5",
    signUpErrorCode51 = "signUp.error.code.51",
    signUpErrorCode52 = "signUp.error.code.52",
    signUpErrorCode53 = "signUp.error.code.53",
    signUpErrorCode54 = "signUp.error.code.54",
    signUpErrorCode6 = "signUp.error.code.6",
    signUpErrorCode7 = "signUp.error.code.7",
    signUpErrorCode8 = "signUp.error.code.8",
    signUpErrorCode9 = "signUp.error.code.9",
    signUpFormAgreeWithThe = "signUp.form.agreeWithThe",
    signUpFormEmail = "signUp.form.email",
    signUpFormFirstName = "signUp.form.firstName",
    signUpFormFullName = "signUp.form.fullName",
    signUpFormLastName = "signUp.form.lastName",
    signUpFormPassword = "signUp.form.password",
    signUpFormPhoneNumber = "signUp.form.phoneNumber",
    signUpFormTermsAndConditions = "signUp.form.termsAndConditions",
    signUpFormVerificationCode = "signUp.form.verificationCode",
    signUpPasswordErrorRegEx0 = "signUp.password.error.RegEx0",
    signUpPasswordErrorRegEx1 = "signUp.password.error.RegEx1",
    signUpPasswordErrorRegEx2 = "signUp.password.error.RegEx2",
    signUpPasswordErrorRegEx3 = "signUp.password.error.RegEx3",
    signUpPasswordErrorRegEx4 = "signUp.password.error.RegEx4",
    signUpPasswordErrorRegEx5 = "signUp.password.error.RegEx5",
    signUpTitle = "signUpTitle",
    signals = "signals",
    signalsAlertInfo = "signalsAlertInfo",
    signalsAlertTitle = "signalsAlertTitle",
    signalsFilterABCD = "signals.filter.ABCD",
    signalsFilterAscendingTriangle = "signals.filter.AscendingTriangle",
    signalsFilterButterfly = "signals.filter.Butterfly",
    signalsFilterChannelDelUp = "signals.filter.ChannelDelUp",
    signalsFilterChannelDown = "signals.filter.ChannelDown",
    signalsFilterDescendingTriangle = "signals.filter.DescendingTriangle",
    signalsFilterDoubleBottom = "signals.filter.DoubleBottom",
    signalsFilterDoubleTop = "signals.filter.DoubleTop",
    signalsFilterFallingWedge = "signals.filter.FallingWedge",
    signalsFilterFlag = "signals.filter.Flag",
    signalsFilterGartley = "signals.filter.Gartley",
    signalsFilterHeadAndShoulders = "signals.filter.HeadAndShoulders",
    signalsFilterInverseHeadAndShoulders = "signals.filter.InverseHeadAndShoulders",
    signalsFilterPennant = "signals.filter.Pennant",
    signalsFilterRectangle = "signals.filter.Rectangle",
    signalsFilterResistance = "signals.filter.Resistance",
    signalsFilterRisingWedge = "signals.filter.RisingWedge",
    signalsFilterSupport = "signals.filter.Support",
    signalsFilterThreeDrive = "signals.filter.ThreeDrive",
    signalsFilterThreePointExtension = "signals.filter.ThreePointExtension",
    signalsFilterThreePointRetracement = "signals.filter.ThreePointRetracement",
    signalsFilterTriangle = "signals.filter.Triangle",
    signalsFilterTripleBottom = "signals.filter.TripleBottom",
    signalsFilterTripleTop = "signals.filter.TripleTop",
    skipEducationMode = "skipEducationMode",
    slTpRateRange = "slTpRateRange",
    specialOffers = "specialOffers",
    startTrading = "startTrading",
    stop = "stop",
    stopLoss = "stopLoss",
    stopLossDescription = "stopLossDescription",
    stopLossEstimated = "stopLossEstimated",
    stopLossOutOfRange = "stopLossOutOfRange",
    stopLossSubtitle = "stopLossSubtitle",
    submit = "submit",
    supportSubtitle = "supportSubtitle",
    symbolCategoryCommodity = "symbol.category.Commodity",
    symbolCategoryCrypto = "symbol.category.Crypto",
    symbolCategoryCurrency = "symbol.category.Currency",
    symbolCategoryDerivatives = "symbol.category.Derivatives",
    symbolCategoryETF = "symbol.category.ETF",
    symbolCategoryFX = "symbol.category.FX",
    symbolCategoryIndex = "symbol.category.Index",
    symbolCategoryNotSet = "symbol.category.NotSet",
    symbolCategoryStock = "symbol.category.Stock",
    symbolNotFound = "symbol.notFound",
    symbols = "symbols",
    symbolsAdditionalInfo = "symbols.AdditionalInfo",
    symbolsAlerts = "symbols.alerts",
    symbolsCloseAmount = "symbols.closeAmount",
    symbolsCloseRate = "symbols.closeRate",
    symbolsContinents = "symbols.continents",
    symbolsEntryOrder = "symbols.entryOrder",
    symbolsFiltersCloseMarkets = "symbols.filters.closeMarkets",
    symbolsFiltersOpenCloseMarkets = "symbols.filters.openCloseMarkets",
    symbolsFiltersOpenMarkets = "symbols.filters.openMarkets",
    symbolsGoToPortfolio = "symbols.goToPortfolio",
    symbolsMarketOrder = "symbols.marketOrder",
    symbolsNeedToDeposit = "symbols.needToDeposit",
    symbolsNoActiveSymbols = "symbols.noActiveSymbols",
    symbolsOrderRate = "symbols.orderRate",
    symbolsOrderType = "symbols.orderType",
    symbolsRequiredMargin = "symbols.requiredMargin",
    takeProfit = "takeProfit",
    takeProfitDescription = "takeProfitDescription",
    takeProfitEstimated = "takeProfitEstimated",
    takeProfitOutOfRange = "takeProfitOutOfRange",
    takeProfitSubtitle = "takeProfitSubtitle",
    target = "target",
    targetPeriod = "targetPeriod",
    timeRange = "timeRange",
    title = "title",
    titleAccountOverview = "title.accountOverview",
    titleAccountSettings = "title.accountSettings",
    titleAlerts = "title.alerts",
    titleEconomicCalendar = "title.economicCalendar",
    titleLessons = "title.lessons",
    titleMyTrades = "title.myTrades",
    titleNews = "title.news",
    titlePromotions = "title.promotions",
    titleSignals = "title.signals",
    titleSymbols = "title.symbols",
    titleTechnicalAnalysis = "title.technicalAnalysis",
    titleTradingOpportunities = "title.tradingOpportunities",
    todayTopMovers = "todayTopMovers",
    tools = "tools",
    topUp = "topUp",
    topUpAccount = "topUpAccount",
    total = "total",
    totalProfit = "totalProfit",
    trade = "trade",
    tradeColumnAction = "trade.column.action",
    tradeColumnActions = "trade.column.actions",
    tradeColumnAdded = "trade.column.added",
    tradeColumnAlert = "trade.column.alert",
    tradeColumnAlertAmount = "trade.column.alertAmount",
    tradeColumnAlertBuy = "trade.column.alertBuy",
    tradeColumnAlertSell = "trade.column.alertSell",
    tradeColumnAlertType = "trade.column.alertType",
    tradeColumnAmount = "trade.column.amount",
    tradeColumnBalance = "trade.column.balance",
    tradeColumnBuy = "trade.column.buy",
    tradeColumnChart1d = "trade.column.chart1d",
    tradeColumnCloseDate = "trade.column.closeDate",
    tradeColumnCloseRate = "trade.column.closeRate",
    tradeColumnCreatedDate = "trade.column.createdDate",
    tradeColumnDescription = "trade.column.description",
    tradeColumnDirection = "trade.column.direction",
    tradeColumnExposure = "trade.column.exposure",
    tradeColumnHighLow = "trade.column.high.low",
    tradeColumnInterval = "trade.column.interval",
    tradeColumnMarketRate = "trade.column.marketRate",
    tradeColumnOpenDate = "trade.column.openDate",
    tradeColumnOpenRate = "trade.column.openRate",
    tradeColumnOrder = "trade.column.order",
    tradeColumnOrderDate = "trade.column.orderDate",
    tradeColumnOrderRate = "trade.column.orderRate",
    tradeColumnPerformedBy = "trade.column.performedBy",
    tradeColumnPrice = "trade.column.price",
    tradeColumnProbability = "trade.column.probability",
    tradeColumnSell = "trade.column.sell",
    tradeColumnSignalRRR = "trade.column.signalRRR",
    tradeColumnStopLoss = "trade.column.stopLoss",
    tradeColumnSymbol = "trade.column.symbol",
    tradeColumnTakeProfit = "trade.column.takeProfit",
    tradeColumnTarget = "trade.column.target",
    tradeColumnTime = "trade.column.time",
    tradeColumnTotalProfit = "trade.column.totalProfit",
    tradeColumnTradingEntityId = "trade.column.tradingEntityId",
    tradeColumnTrend = "trade.column.trend",
    tradeColumnTrigger = "trade.column.trigger",
    tradeColumnType = "trade.column.type",
    tradeColumnValue = "trade.column.value",
    tradeDeleted = "tradeDeleted",
    tradeDetails = "tradeDetails",
    tradeExecuted = "tradeExecuted",
    tradeFailedToDelete = "tradeFailedToDelete",
    tradeLossCoverage = "tradeLossCoverage",
    tradeManagerTabAlerts = "trade.manager.tab.alerts",
    tradeManagerTabChart = "trade.manager.tab.chart",
    tradeManagerTabEvents = "trade.manager.tab.events",
    tradeManagerTabInfo = "trade.manager.tab.info",
    tradeManagerTabNews = "trade.manager.tab.news",
    tradeManagerTabPromotions = "trade.manager.tab.promotions",
    tradeManagerTabSignals = "trade.manager.tab.signals",
    tradeManagerTabTrade = "trade.manager.tab.trade",
    tradeNumber = "trade.number",
    tradePlaced = "tradePlaced",
    tradePlacedEntryOrder = "tradePlacedEntryOrder",
    tradeSpreadCashback = "tradeSpreadCashback",
    tradeSymbolNotification = "trade.symbolNotification",
    tradeSymbolNotificationCheckbox = "trade.symbolNotificationCheckbox",
    tradeSymbolNotificationExpire = "trade.symbolNotificationExpire",
    tradeSymbolNotificationRollConfirmation = "trade.symbolNotificationRollConfirmation",
    tradeSymbolNotificationRollFailed = "trade.symbolNotificationRollFailed",
    tradeSymbolNotificationRollSuccess = "trade.symbolNotificationRollSuccess",
    tradeUpdated = "tradeUpdated",
    tradesActivity = "tradesActivity",
    tradesLeft = "tradesLeft",
    tradingHours = "tradingHours",
    tradingProfile = "tradingProfile",
    trends = "trends",
    trigger = "trigger",
    type = "type",
    units = "units",
    unitsAt = "unitsAt",
    unlimited = "unlimited",
    upTo = "upTo",
    update = "update",
    updateAlert = "updateAlert",
    updateNow = "updateNow",
    username = "username",
    usingDemo = "usingDemo",
    value = "value",
    viewAll = "viewAll",
    views = "views",
    walkthroughs = "walkthroughs",
    wantToCloseTrade = "wantToCloseTrade",
    wantToCloseTrades = "wantToCloseTrades",
    wantToDeleteOrder = "wantToDeleteOrder",
    wantToDeleteOrders = "wantToDeleteOrders",
    warning = "warning",
    withdrawableEquityNoLogs = "withdrawableEquityNoLogs",
    withdrawalContinue = "withdrawalContinue",
    withdrawalDescriptionSuccess = "withdrawal.description.success",
    withdrawalExceeds = "withdrawalExceeds",
    withdrawalFormAmountLabel = "withdrawalFormAmountLabel",
    withdrawalListItemAmount = "withdrawalListItemAmount",
    withdrawalListItemCurrency = "withdrawalListItemCurrency",
    withdrawalListItemDate = "withdrawalListItemDate",
    withdrawalListItemId = "withdrawalListItemId",
    withdrawalListTitle = "withdrawalListTitle",
    withdrawalPrice = "withdrawalPrice",
    withdrawalReasonPlaceholder = "withdrawalReasonPlaceholder",
    withdrawalSubtitleStep3 = "withdrawal.subtitle.step3",
    withdrawalTitleCanceled = "withdrawal.title.canceled",
    withdrawalTitleStep3 = "withdrawal.title.step3",
    withdrawalTitleSuccess = "withdrawal.title.success",
    workingHours = "workingHours",
    yes = "yes",
    yesReject = "yesReject",
    yourSessionExpired = "yourSessionExpired",
}
